import { getValidationMessage } from '@gef-ui/localization/messages';

const mockBe = (fieldValue) => () =>
	new Promise((resolve) => {
		setTimeout(() => {
			if (fieldValue === '1111111111') {
				resolve(true);
			} else {
				resolve(false);
			}
		}, 1000);
	});

export const asyncCheckPS =
	({ msg }) =>
	({ fieldValue }) =>
	(dispatch) => {
		return dispatch(mockBe(fieldValue)).then((success) => {
			return success ? false : getValidationMessage(msg);
		});
	};
